import { ResponsiveRadar } from "@nivo/radar";
import React from "react";

export const RadarGraphics = ({ data = [] }) => {

    return (
        <ResponsiveRadar
            data={data}
            keys={["project"]}
            indexBy="name"
            valueFormat=">-.2f"
            margin={{ top: 70, right: 40, bottom: 40, left: 0 }}
            borderColor={{ from: "color" }}
            gridLabelOffset={10}
            dotSize={10}
            dotColor={{ theme: "background" }}
            dotBorderWidth={2}
            colors={{ scheme: "nivo" }}
            blendMode="multiply"
            motionConfig="wobbly"
            animate={false}
        />
    );
};
